// @flow
import React from 'react';

import { Introduction } from 'Components/frameworks/introduction/Introduction.jsx';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';

type Props = {
  config: CMSContent,
  hasShadow?: boolean,
  icon?: string,
  id?: string,
  smallTitle: string,
  subTitle: string,
  text: string,
  theme: string,
  title: string,
};

export function TitleAndTextLine({
  config,
  hasShadow,
  icon,
  id,
  smallTitle,
  subTitle,
  text,
  theme,
  title,
}: Props) {
  return (
    <SiteContainer
      hasBorders={hasShadow}
      hasShadowOutset={hasShadow}
      id={id}
      className="Line Line-Introduction"
    >
      <Introduction
        className="py-4"
        iconName={icon}
        small={smallTitle}
        subtitle={subTitle}
        title={title}
        text={text}
        theme={theme}
        seeMoreLabel={config.common.viewMore}
        seeLessLabel={config.common.loadLess}
        isTextSeeMoreCollapseEnabled
      />
    </SiteContainer>
  );
}
